import { render, staticRenderFns } from "./Footer.vue?vue&type=template&id=69759b9a&scoped=true&"
var script = {}
import style0 from "./Footer.vue?vue&type=style&index=0&id=69759b9a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "69759b9a",
  null
  
)

component.options.__file = "Footer.vue"
export default component.exports